var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYenCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V7.25H2V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.75V15C2 16.1046 2.89543 17 4 17H10.5764C10.5261 16.674 10.5 16.3401 10.5 16C10.5 12.4101 13.4101 9.5 17 9.5C19.0104 9.5 20.8077 10.4127 22 11.8464V8.75H2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21C19.7614 21 22 18.7614 22 16C22 13.2386 19.7614 11 17 11C14.2386 11 12 13.2386 12 16C12 18.7614 14.2386 21 17 21ZM15.5529 12.4932L17 14.0719L18.4471 12.4932C18.727 12.1879 19.2015 12.1672 19.5068 12.4471C19.8121 12.727 19.8328 13.2015 19.5529 13.5068L17.75 15.4736V16.25H18.5C18.9142 16.25 19.25 16.5858 19.25 17C19.25 17.4142 18.9142 17.75 18.5 17.75H17.75V19C17.75 19.4142 17.4142 19.75 17 19.75C16.5858 19.75 16.25 19.4142 16.25 19V17.75H15.5C15.0858 17.75 14.75 17.4142 14.75 17C14.75 16.5858 15.0858 16.25 15.5 16.25H16.25V15.4736L14.4471 13.5068C14.1672 13.2015 14.1879 12.727 14.4932 12.4471C14.7985 12.1672 15.273 12.1879 15.5529 12.4932Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYenCard);
export default __webpack_public_path__ + "static/media/yen-card.517ea2be59f92b0a1e2808e65355b88c.svg";
export { ForwardRef as ReactComponent };